/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureACircleUpIcon24Solid = forwardRef('ArrowFigureACircleUpIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm0 16a1 1 0 0 1-1-1V8.961l-2.293 2.293A1 1 0 0 1 7.293 9.84l3.006-3.006c.94-.94 2.463-.94 3.402 0l3.006 3.006a1 1 0 0 1-1.414 1.414L13 8.961V17a1 1 0 0 1-1 1Z" })));
});
